<template>
  <div v-if="mapLayersOptions.length > 0" class="tracking-records-map-options-wrapper">
    <div cols="auto" class="header-wrapper">
      <h2 class="header">{{ $t('tolling.tracking_records.display_on_map') }}</h2>
    </div>
    <div cols="auto" class="switch-wrapper">
      <div
        v-if="getLayerOptionsBy('raw')"
        class="switch-btn"
      >
        <div class="switch-title">{{ $t(rawTitle) }}</div>
      </div>
      <div
        v-if="getLayerOptionsBy('mapMatched')"
        class="switch-btn"
      >
        <div class="switch-title">
          {{ $t(mapMatchedTitle) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { mapLayersOptions } = defineProps({
  mapLayersOptions: {
    type: Array<{ title: string, value: string }>,
    default: [] as Array<{ title: string, value: string }>
  }
});

function getLayerOptionsBy(title: string) {
  return mapLayersOptions.find(layerOption => layerOption.value === title);
}

const rawTitle = computed(() => {
  const obj = getLayerOptionsBy('raw');
  return obj ? obj.title : 'common.status.error';
});

const mapMatchedTitle = computed(() => {
  const obj = getLayerOptionsBy('mapMatched');
  return obj ? obj.title : 'common.status.error';
});
</script>
<style lang="scss" scoped>
@import './styles/tracking-records-map-options.scss';
</style>
